export { default } from './thumb-list.jsx';